module.exports = "../../../../platform/assets/pageMainIcon/business_danjuweihulei8.svg";